// ─────────────────────────────────────────────────────────────────────
// reglagesPiece — CE QUI EST REPLIÉ DOIT DIRE CE QU'IL CONTIENT
//
// Neuf champs de réglage vivaient dépliés sur chaque pièce : le prix
// matière retenu, le transport, le coefficient matière, les deux taux,
// le coefficient de sécurité, le minimum de facturation et l'arrondi.
// Ils sont TOUS facultatifs, ils ont TOUS un défaut venant des
// paramètres, et on y touche dans moins d'un devis sur cinq.
//
// Les replier fait gagner l'essentiel de la hauteur d'écran. Mais un
// repli est dangereux pour une raison précise :
//
//   ON NE CACHE JAMAIS UN MONTANT QUI PART CHEZ LE CLIENT.
//
// D'où cette fonction, et d'où le fait qu'elle rende une LISTE et pas
// un booléen. Le repli s'ouvre tout seul dès qu'un réglage porte une
// valeur propre à la pièce, et son intitulé NOMME lesquels — « 2
// réglages : taux machine, minimum de facturation ». Un repli fermé
// affirme donc quelque chose de vérifiable : rien de particulier ici.
//
// Un booléen aurait dit « il y a quelque chose » sans dire quoi, ce qui
// oblige à ouvrir pour savoir — c'est-à-dire à ne rien replier du tout.
// ─────────────────────────────────────────────────────────────────────

/**
 * Les réglages qui portent une valeur PROPRE À LA PIÈCE.
 *
 * `null` est la valeur normale de chacun : elle veut dire « suis les
 * paramètres ». Un champ rempli est une décision, un champ vide n'en
 * est pas une — c'est la même règle que l'encart « ce qui prévaut ».
 *
 * Le transport est à part : il est pré-rempli à 0, et un zéro DÉCIDÉ
 * n'est pas une décision à signaler. Seul un transport facturé compte.
 *
 * `rounding_rule` n'entre pas dans cette liste : la colonne porte
 * toujours une valeur, donc elle ne distingue rien. Elle est nommée
 * dans le résumé du repli à la place — voir `resumeReglages`.
 *
 * LES DEUX TAUX N'Y SONT PAS NON PLUS, et c'est un fait et non un
 * choix : `pieces.taux_machine` et `pieces.taux_humain` n'existent pas.
 * Il y a `taux_machine_applique`, qui est la PHOTO du taux au
 * chiffrage. Les taux valent pour tout l'atelier et se règlent dans les
 * Paramètres (§2bis) ; le bloc les AFFICHE au-dessus du prix, il ne les
 * saisit pas. Voir l'en-tête de `TauxBloc.jsx`.
 */
export function reglagesRenseignes(piece) {
  const p = piece ?? {};
  const nommes = [
    ['montant_matiere_retenu', 'prix matière'],
    ['coefficient_matiere', 'coefficient matière'],
    ['coefficient_securite', 'coefficient de sécurité'],
    ['min_invoice', 'minimum de facturation'],
  ]
    .filter(([clef]) => p[clef] !== null && p[clef] !== undefined && p[clef] !== '')
    .map(([, libelle]) => libelle);

  if (Number(p.transport_matiere) > 0) nommes.push('transport matière');
  return nommes;
}

/**
 * Ce que l'intitulé du repli affiche à droite de son titre.
 *
 * Toujours quelque chose : un repli qui ne dit rien de son contenu
 * demande de l'ouvrir pour savoir s'il faut l'ouvrir.
 */
export function resumeReglages(piece) {
  const poses = reglagesRenseignes(piece);
  if (!poses.length) return 'valeurs par défaut';
  return `${poses.length} réglage${poses.length > 1 ? 's' : ''} : ${poses.join(', ')}`;
}

export default reglagesRenseignes;
